$(function () {
  'use strict';

  $('[data-toggle="tooltip"]').tooltip({ boundary: 'window', container: 'body' });
});
